function UserDetailsActivityTab() {
  return <div>WORK IN PROGRESS 🚧</div>;
}

export default UserDetailsActivityTab;
